module.exports = __webpack_public_path__ + "static/media/97694c53-4e94-4f9e-969b-a148adfcdcfd.e55891f8.woff2";